export function detectTouch() {
  // if (typeof window !== 'undefined') {
  //   return Boolean(
  //     'ontouchstart' in (window as Window) ||
  //     window.navigator.maxTouchPoints > 0 ||
  //     window.navigator.msMaxTouchPoints > 0
  //   );
  // }
  return (
    !!(typeof window !== 'undefined' && ('ontouchstart' in (window as Window) || window.navigator.maxTouchPoints > 0)) ||
    !!(typeof navigator !== 'undefined' && navigator.maxTouchPoints)
  );
}

export function isIPhone() {
  return !!(typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('iphone') > -1);
}
